export const route = {
  NOT_FOUND: "*",
  HOME: "/",
  FAQ: "/#faq-section",
  NOTICE: "/notice",
  ABOUT: "/about",
  PRESENTER: "/presenter",
  PRIVACY_POLICY: "/privacy-policy",
  SESSION: "/session",
  APP_SESSION: "app/session",
  MY_SESSION: "app/my-session",
  OFFLINE: "/offline",
  LOCATION: "/#location-section",
  ONLINE_STREAMING: "/online-streaming"
} as const
